import { AfterViewInit, Component, ElementRef, Input, ViewChild } from "@angular/core";
import { IPictureData } from "src/app/dynamic-module/lib/public_api";
import { ILinkTyped } from "src/app/shared/interface/link";
import { IUProperty } from "src/app/shared/interface/umbraco-property";
import { ITitleStyleSettings } from "../../../../shared/interface/title-style-settings";
import { IRteStyleSettings } from "../../../../shared/interface/rte-style-settings";
import { applyTitleSettings } from "../../../../shared/utils/title-style-settings-utils";
import { applyRteSettings } from "../../../../shared/utils/rte-style-settings-utils";


export interface ILicenseV3Items {
  licenseName: IUProperty<string>;
  backgroundImage: IUProperty<IPictureData>;
  description: IUProperty<string>;
  pricePerMonth: IUProperty<number>;
  pricePerYear: IUProperty<number>;
  link: IUProperty<ILinkTyped>;
  focused: IUProperty<boolean>;
  bodyColor: IUProperty<string>;
  linkColor: IUProperty<string>;

  titleStyleSettingsComposition?: ITitleStyleSettings;
  rteStyleSettingsComposition?: IRteStyleSettings;
}

@Component({
  selector: "app-license-panel-item",
  templateUrl: "./license-panel-item.component.html",
  styleUrls: ["./license-panel-item.component.less"],
})
export class LicensePanelItemComponent implements AfterViewInit {
  @Input() item: ILicenseV3Items;
  @ViewChild('nameEl', { static: false }) nameEl: ElementRef<HTMLElement>;
  @ViewChild('descriptionEl', { static: false }) descriptionEl: ElementRef<HTMLElement>;

  constructor(private hostRef: ElementRef) {}

  ngAfterViewInit(): void {
    this.setCustomThemeProperties(this.item);
  }

  private setCustomThemeProperties(d: ILicenseV3Items) {
    applyTitleSettings(this.item, this.nameEl);
    applyRteSettings(this.item, this.descriptionEl);

    if (d.bodyColor && d.bodyColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--item-body-color",
        d.bodyColor.value
      );
    }
    if (d.linkColor && d.linkColor.value) {
      this.hostRef.nativeElement.style.setProperty(
        "--item-link-color",
        d.linkColor.value
      );
    }
  }
}
